import { Position, WebPartsObj } from 'src/types'

export const webPartsPositionFilter = (webPartsObjects: WebPartsObj[], position: Position): WebPartsObj[] => {
  return webPartsObjects.filter((webPart) => webPart.position.includes(position))
}
